module.exports = "/images/Ice skating.svg?4f035014fe891e93460df251a03f4ce8";